<template>
  <div class="flex justify-center items-center">
    <img src="../ics/love.svg" class="cursor-pointer mr-3" alt="">
    <img src="../ics/smile.svg" class="cursor-pointer mr-3" alt="">
    <img src="../ics/frown.svg" class="cursor-pointer mr-3" alt="">
    <img src="../ics/toxic.svg" class="cursor-pointer mr-3" alt="">
    <img src="../ics/anger.svg" class="cursor-pointer mr-3" alt="">
    <img src="../ics/cooleye.svg" class="cursor-pointer" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
